import React from "react";

const Pill = (props) => {
  return (
    <div className="rm--pill">
      <p>
        <span>{props.value}</span>
        <i className="icon general-close" onClick={props.onClear}></i>
      </p>
    </div>
  );
};

export const PillNext = (props) => {
  return (
    <div className="rm--pill">
      <p>
        <span>{props.value}</span>
        <a style={{ cursor: 'pointer' }} onClick={(event) => {
          event.preventDefault();
          props.onClear();
        }}>X</a>
      </p>
    </div>
  );
}

export default Pill;
